var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"event-add-view"},[_c('event-card-tabs'),_c('event-card-full',{attrs:{"event-id-to-load":_vm.routerEventId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }